export const LOGIN_BANNER_IMAGE =
  "https://com-hx-ferovinum-assets.s3.eu-west-2.amazonaws.com/images/login-banner.jpg";
